import React from 'react';
import { FormIcon } from '@axiom/ui';
import { Routes, Route } from 'react-router';
import PropTypes from 'prop-types';

import { formatDataTestId } from '../../utils/data-test-util';

import { StyledSideDrawer, DrawerTab } from './SideDrawerStyles';
import { SideDrawerFallback } from './SideDrawerFallback';
import { SideDrawerContainer } from './SideDrawerContainer';

export const SideDrawer = ({ expanded, setExpanded }) => {
  const toggleSideDrawerExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <div style={{ position: 'relative', minHeight: '100%' }}>
      <StyledSideDrawer
        data-test={formatDataTestId('side drawer container')}
        expanded={expanded}
      >
        <Routes>
          <Route
            path=":id/*"
            element={
              <SideDrawerContainer
                expanded={expanded}
                setExpanded={setExpanded}
              />
            }
          />
          <Route
            path="*"
            element={<SideDrawerFallback setExpanded={setExpanded} />}
          />
        </Routes>
      </StyledSideDrawer>
      <DrawerTab
        expanded={expanded}
        onClick={toggleSideDrawerExpanded}
        data-test={formatDataTestId('DrawerTab')}
      >
        <FormIcon />
      </DrawerTab>
    </div>
  );
};

SideDrawer.propTypes = {
  expanded: PropTypes.bool.isRequired,
  setExpanded: PropTypes.func.isRequired,
};
